import { createSlice } from '@reduxjs/toolkit';
import { authApi } from './authApi';

// Check localStorage on initial load
const getInitialAuthState = () => {
  const token = localStorage.getItem('authToken');
  
  if (token) {
    return {
      user: { token }, // Minimal user object with token
      isAuthenticated: true,
      loading: false,
      error: null,
    };
  }
  
  return {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  };
};

const initialState = getInitialAuthState();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Set user data after successful login
    setUser: (state, action) => {
      state.user = action.payload || {}; // or null if you prefer
      state.isAuthenticated = true;
      state.error = null;
    },
    
    
    // Clear user data on logout
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem('authToken');
    },
    
    // Clear error messages
    clearError: (state) => {
      state.error = null;
    },
    
    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    
    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(authApi.endpoints.login.matchPending, setLoading)
    .addMatcher(authApi.endpoints.login.matchRejected, setError)
    .addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
      console.log('Login successful:', action.payload);
      state.user = action.payload;
      state.isAuthenticated = true;
      state.error = null;
    });
  },
});

export const { setUser, logout, clearError, setLoading, setError } = authSlice.actions;
export default authSlice.reducer; 